var BEES = require('serialisers/byte-encoded-enum-serialiser');
var Codec = require('io/codec');
var util = require('content/util');

var Encoding = {
    NONE : 0,
    ENCRYPTED : 1,
    COMPRESSED : 2
};

module.exports = {
    read : function(bis) {
        var encoding = BEES.read(bis, Encoding);
        var bytes = Codec.readBytes(bis);

        switch (encoding) {
        case Encoding.NONE :
            return bytes;
        default :
            throw new Error('Unable to handle encoding type ' + encoding);
        }
    },
    write : function(bos, content) {
        BEES.write(bos, Encoding.NONE);
        Codec.writeBytes(bos, util.getBytes(content));
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/content/serialiser.js
// module id = 113
// module chunks = 1